import { pj, type PjshellId } from './pjshell'

export function PJ({ id, vars }: { id: PjshellId; vars?: Record<string, string> }) {
  return <>{pj(id, vars)}</>
}
